import * as React from 'react';
import styled from 'styled-components';

import { IconSystemV2CourseTestMic } from '@doltech/icons/SystemV2/IconSystemV2CourseTestMic';
import { IconSystemV2OtherStop } from '@doltech/icons/SystemV2/IconSystemV2OtherStop';
import { IconSystemV2CoursePause } from '@doltech/icons/SystemV2/IconSystemV2CoursePause';
import { IconSystemV2CoursePlay } from '@doltech/icons/SystemV2/IconSystemV2CoursePlay';
import { ButtonIconPrimaryGeneral } from '../../Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';

const Container = styled.div``;

const BUTTON_TYPE = {
  RECORD: 'record',
  STOP: 'stop',
  PAUSE: 'pause',
  PLAY: 'play',
} as const;

interface MediaButtonProps {
  type?: typeof BUTTON_TYPE[keyof typeof BUTTON_TYPE];
  size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'double-x-large';
  onClick?: () => void;
  disabled?: boolean;
  transparent?: boolean;
}

export const MediaButton = (props: MediaButtonProps) => {
  const { type, size = 'x-large', onClick, disabled = false, transparent = false } = props;

  const icon = React.useMemo(() => {
    switch (type) {
      case BUTTON_TYPE.RECORD:
        return <IconSystemV2CourseTestMic />;
      case BUTTON_TYPE.STOP:
        return <IconSystemV2OtherStop />;
      case BUTTON_TYPE.PAUSE:
        return <IconSystemV2CoursePause />;
      case BUTTON_TYPE.PLAY:
        return <IconSystemV2CoursePlay />;
      default:
    }
    return null;
  }, [type]);

  return (
    <Container className="media-button">
      <ButtonIconPrimaryGeneral
        type="primary"
        size={size}
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        transparent={transparent}
      />
    </Container>
  );
};
